import { deepEqual } from 'fast-equals';
import * as deepmerge from 'deepmerge';
export const onChange = (STORE, callback) => {
    let previous = null;
    return STORE.subscribe(data => {
        if (previous === null) {
            previous = structuredClone(data);
            return;
        }
        if (deepEqual(data, previous)) {
            return;
        }
        previous = structuredClone(data);
        callback(data);
    });
};
const arrayMerge = (destination, source) => {
    if (Array.isArray(source) && source.length === 0) {
        return destination;
    }
    return source;
};
export const merge = (data) => deepmerge.all(data, { arrayMerge });
